export const initialState = () => ({
  route: null,
  sellersOptions: [],
  usersOptions: [],
})
